export const SIDEBAR_WIDTH_MOBILE = '18rem';
